var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wh100" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "form-center",
      },
      [
        _vm._l(_vm.tableData, function (item) {
          return _c(
            "el-card",
            {
              key: item.Id,
              staticClass: "box-card",
              attrs: { "body-style": "padding: 10px;" },
            },
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("span", [
                    _c("span", { attrs: { cliass: "span" } }, [
                      _vm._v(_vm._s(item.DeviceItemName)),
                    ]),
                    _c("span", { attrs: { cliass: "span" } }, [
                      _vm._v("（" + _vm._s(item.DeviceItemCode) + "）"),
                    ]),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", padding: "3px 0" },
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.openView(item)
                        },
                      },
                    },
                    [_vm._v(" 查看详情 ")]
                  ),
                ],
                1
              ),
              _c("div", { staticStyle: { padding: "15px 0px" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: `工单编号：${item.Code}`,
                          placement: "top",
                          "open-delay": 300,
                        },
                      },
                      [
                        _c("div", { staticClass: "item" }, [
                          _c("span", { attrs: { cliass: "span" } }, [
                            _vm._v("工单编号："),
                          ]),
                          _c("div", { staticClass: "p" }, [
                            _vm._v(_vm._s(item.Code)),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: `类型：${item.TypeName}`,
                          placement: "top",
                          "open-delay": 300,
                        },
                      },
                      [
                        _c("div", { staticClass: "item" }, [
                          _c("span", { attrs: { cliass: "span" } }, [
                            _vm._v("类型："),
                          ]),
                          _c("div", { staticClass: "p" }, [
                            _vm._v(_vm._s(item.TypeName)),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-top": "10px" } },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: `工单日期：${
                            item.WorkOrderDate
                              ? _vm
                                  .moment(item.WorkOrderDate)
                                  .format("YYYY-MM-DD")
                              : ""
                          }`,
                          placement: "top",
                          "open-delay": 300,
                        },
                      },
                      [
                        _c("div", { staticClass: "item" }, [
                          _c("span", { attrs: { cliass: "span" } }, [
                            _vm._v("工单日期："),
                          ]),
                          _c("div", { staticClass: "p" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.WorkOrderDate
                                    ? _vm
                                        .moment(item.WorkOrderDate)
                                        .format("YYYY-MM-DD")
                                    : ""
                                ) +
                                " "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: `状态：${
                            item.State === 0
                              ? "待提交"
                              : item.State === 1
                              ? "已提交"
                              : item.State === 2
                              ? "进行中"
                              : item.State === 3
                              ? "已完成"
                              : ""
                          }`,
                          placement: "top",
                          "open-delay": 300,
                        },
                      },
                      [
                        _c("div", { staticClass: "item" }, [
                          _c("span", { attrs: { cliass: "span" } }, [
                            _vm._v("状态："),
                          ]),
                          _c(
                            "div",
                            { staticClass: "p" },
                            [
                              item.State === 0
                                ? _c("el-tag", [_vm._v("待提交")])
                                : _vm._e(),
                              item.State === 1
                                ? _c("el-tag", { attrs: { type: "success" } }, [
                                    _vm._v("已提交"),
                                  ])
                                : _vm._e(),
                              item.State === 2
                                ? _c("el-tag", { attrs: { type: "warning" } }, [
                                    _vm._v("进行中"),
                                  ])
                                : _vm._e(),
                              item.State === 3
                                ? _c("el-tag", { attrs: { type: "success" } }, [
                                    _vm._v("已完成"),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "margin-top": "10px" } },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: `安装位置：${item.InstallationAreaName}`,
                          placement: "top",
                          "open-delay": 300,
                        },
                      },
                      [
                        _c("div", { staticClass: "item" }, [
                          _c("span", { attrs: { cliass: "span" } }, [
                            _vm._v("安装位置："),
                          ]),
                          _c("div", { staticClass: "p" }, [
                            _vm._v(
                              " " + _vm._s(item.InstallationAreaName) + " "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    item.SupplierName
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: `供应商：${item.SupplierName}`,
                              placement: "top",
                              "open-delay": 300,
                            },
                          },
                          [
                            _c("div", { staticClass: "item" }, [
                              _c("span", { attrs: { cliass: "span" } }, [
                                _vm._v("供应商："),
                              ]),
                              _c("div", { staticClass: "p" }, [
                                _vm._v(" " + _vm._s(item.SupplierName) + " "),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          )
        }),
        _vm.tableData.length == 0
          ? _c("el-empty", { attrs: { description: "暂无数据" } })
          : _vm._e(),
      ],
      2
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "footer",
      },
      [
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.pagination.PageIndex,
            "page-sizes": _vm.pagination.PageSizes,
            "page-size": _vm.pagination.PageRows,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.pagination.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }